<template>
  <span class="ml-tag" :style="`background: ${bg}`">
    <span :style="`color: ${color}`">
      <b v-if="dot" :style="`background: ${color};`" />
      <slot />
    </span>
  </span>
</template>
<script>
export default {
  name: 'MlTag',
  props: {
    type: {
      type: [String],
      default() {
        return 'info'
      }
    },
    dot: Boolean
  },
  computed: {
    bg() {
      let color = '#f0f1fe'
      switch (this.type) {
        case 'success':
          color = '#CDFFCD'
          break
        case 'info':
          color = '#f4f4f5'
          break
        case 'danger':
          color = '#FFEBEB'
          break
        case 'warn':
          color = '#fdf6ec'
          break
        default:
          color = '#f0f1fe'
          break
      }
      return color
    },
    color() {
      let color = '#6C74F7'
      switch (this.type) {
        case 'success':
          color = '#24BA0CFF'
          break
        case 'info':
          color = '#909399'
          break
        case 'danger':
          color = '#FE1E1E'
          break
        case 'warn':
          color = '#e6a23c'
          break
        default:
          color = '#6C74F7'
          break
      }
      return color
    }
  }
}
</script>
<style scoped lang="scss">
.ml-tag {
  border-radius: 20px;
  background: rgba(205, 255, 205);
  padding: 4px 12px;
  font-size: 12px;

  b {
    width: 6px;
    height: 6px;
    margin-right: 2px;
    margin-bottom: 1px;
    display: inline-block;
    border-radius: 50%;
  }
}
</style>
